import CalendarToday from '@mui/icons-material/CalendarToday';
import ChatBubbleOutline from '@mui/icons-material/ChatBubbleOutline';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { FileSetDto } from 'api';
import { getUrlFileSetDownload } from 'api/ApiUrls';
import UserIcon from 'assets/volvoIcons/People/UserIcon';
import { FileDisplayBase } from 'library/components/controls/files/FileDisplayBase';
import {
	DeleteRefreshFunction,
	UnitFileRemoveButton,
} from 'library/components/controls/files/UnitFileRemoveButton';
import { getFileType } from 'library/components/controls/files/functions';
import { getLocalizedDateFormat } from 'library/formatters/DateFormatter';

export const FileSetDisplay = ({
	id,
	comment,
	submittedBy,
	timestamp,
	files,
	onDelete,
}: DeleteRefreshFunction & FileSetDto) => {
	return (
		<Box
			className="server-file-display_root"
			sx={{
				display: 'grid',
				alignItems: 'center',
				gap: 2,

				gridTemplateAreas: {
					xs: `"files files"
						"comment comment"
						"date user"`,
					md: `"files comment date user"`,
				},

				gridTemplateColumns: {
					xs: '1fr 1fr',
					md: '6fr 7fr 2fr 3fr',
				},

				'.server-file-display_comment-icon, .server-file-display_calendar-icon, .server-file-display_user-icon':
					{
						verticalAlign: 'bottom',
						mr: 1,
					},
			}}>
			<Stack
				direction="column"
				spacing={2}
				sx={{
					gridArea: 'files',
				}}>
				{files.map((file) => (
					<Box
						key={file.id}
						sx={{
							display: 'flex',
						}}>
						<FileDisplayBase
							sx={(theme) => ({
								[theme.breakpoints.only('xs')]: {
									flex: '1',
								},
							})}
							name={file.fileName}
							url={getUrlFileSetDownload(id, file.id)}
							type={getFileType(file.fileName)}
						/>
						<UnitFileRemoveButton
							fileSetId={id}
							fileId={file.id}
							onDelete={onDelete}
						/>
					</Box>
				))}
			</Stack>
			<Typography
				sx={{
					gridArea: 'comment',
					whiteSpace: 'pre-wrap',
					display: 'inline-flex',
				}}>
				<>
					<ChatBubbleOutline color="disabled" />

					<Typography
						sx={{
							paddingLeft: '1em',
						}}>
						{comment}
					</Typography>
				</>
			</Typography>
			<Typography
				sx={{
					gridArea: 'date',
				}}>
				<CalendarToday
					className="server-file-display_calendar-icon"
					color="disabled"
				/>
				{getLocalizedDateFormat(timestamp)}
			</Typography>
			<Typography
				sx={{
					gridArea: 'user',
				}}>
				<UserIcon
					className="server-file-display_user-icon"
					color="primary"
					opacity={0.4}
				/>
				{submittedBy}
			</Typography>
		</Box>
	);
};
